module.exports = __webpack_public_path__ + "static/media/twitter.9d465b2c.svg";